/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { BillingEvent } from './BillingEvent';
import {
    BillingEventFromJSON,
    BillingEventFromJSONTyped,
    BillingEventToJSON,
    BillingEventToJSONTyped,
} from './BillingEvent';

/**
 * 
 * @export
 * @interface ListNextBillingEventsResponse
 */
export interface ListNextBillingEventsResponse {
    /**
     * 
     * @type {Array<BillingEvent>}
     * @memberof ListNextBillingEventsResponse
     */
    data: Array<BillingEvent>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListNextBillingEventsResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListNextBillingEventsResponse interface.
 */
export function instanceOfListNextBillingEventsResponse(value: object): value is ListNextBillingEventsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListNextBillingEventsResponseFromJSON(json: any): ListNextBillingEventsResponse {
    return ListNextBillingEventsResponseFromJSONTyped(json, false);
}

export function ListNextBillingEventsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListNextBillingEventsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(BillingEventFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListNextBillingEventsResponseToJSON(json: any): ListNextBillingEventsResponse {
      return ListNextBillingEventsResponseToJSONTyped(json, false);
  }

  export function ListNextBillingEventsResponseToJSONTyped(value?: ListNextBillingEventsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(BillingEventToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

